import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Select } from 'antd';

import { translate } from 'utils/index';
import { selectAggregatedOrganizations } from 'pages/Organization/selectors';
import { messages } from 'pages/Vendors/VendorsList/messages';
import Filter from 'ui/Filter';

const { Option } = Select;

const FilterParentOrganization = ({ fetchData, filter, ...otherProps }) => {
  const aggregatedOrganizations = useSelector(selectAggregatedOrganizations);

  return (
    <Filter
      filter={filter}
      fetchData={fetchData}
      innerLabel={translate(messages.filterOrganization)}
      {...otherProps}
    >
      {aggregatedOrganizations?.map(({ id, label }) => (
        <Option key={id} id={id} value={label}>
          {label}
        </Option>
      ))}
    </Filter>
  );
};

FilterParentOrganization.propTypes = {
  fetchData: PropTypes.func,
  filter: PropTypes.object,
};

export default FilterParentOrganization;
